import { render, staticRenderFns } from "./SubjectUploader.vue?vue&type=template&id=7972149c&"
import script from "./SubjectUploader.vue?vue&type=script&lang=js&"
export * from "./SubjectUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports